module.exports = __webpack_public_path__ + "static/media/icon-copy-paste.6788d0d8.svg";